import { rgbaToArray, rgbaToHex } from 'hex-and-rgba'

// не используется
export const getBackgroundGradient = (backgroundColor) => {
  console.log('Not used getBackgroundGradient')
    if (backgroundColor.type === 'color') {
      return backgroundColor.colorValue;
    } else {
        let gradient = '';
        backgroundColor.gradientLayers.map((layer, index) => {
            gradient = `linear-gradient(${layer.angle}deg, ${layer.firstColor}, ${layer.secondColor} ${layer.transition}%)` + gradient
            if (index != backgroundColor.gradientLayers.length - 1) {
                gradient = ', ' + gradient
            }
        })
        return gradient
    }
  }

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
  
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
  
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
  
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      //   console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
  
    document.body.removeChild(textArea);
  }
  function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function () {
      console.log(text)
        console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
      console.error('Async: Could not copy text: ', err);
    });
  }
  function renderColorToast(color) {
    const colorSquare = document.createElement('div')
    colorSquare.style.width = '20px'
    colorSquare.style.height = '20px'
    colorSquare.style.marginLeft = '10px'
    colorSquare.style.boxShadow = '0 0 3px rgba(0,0,0,.3)'
    colorSquare.style.background = color
    const copiedToast = document.createElement('div')
    copiedToast.style.display = 'flex'
    copiedToast.style.alignItems = 'center'
    copiedToast.style.justifyContent = 'space-around'
    copiedToast.style.position = 'fixed'
    copiedToast.style.zIndex = '9999'
    copiedToast.style.left = '15px'
    copiedToast.style.top = '80px'
    copiedToast.style.fontSize = '16px'
    copiedToast.style.fontWeight = 'light'
    copiedToast.style.color = '#fff'
    copiedToast.style.padding = '10px'
    copiedToast.style.borderRadius = '5px'
    copiedToast.style.boxShadow = '1px 1px 3px rgba(0,0,0,.3)'
    copiedToast.innerHTML = 'Color copied to clipboard'
    copiedToast.style.background = '#3899ec'
    copiedToast.style.transition = '.2s'
    copiedToast.style.opacity = '0'
    copiedToast.appendChild(colorSquare)
    document.body.appendChild(copiedToast)
    setTimeout(() => {
      copiedToast.style.opacity = '1'
    }, 0)
    setTimeout(() => {
      copiedToast.style.opacity = '0'
    }, 1800)
    setTimeout(() => {
      document.body.removeChild(copiedToast)
    }, 2000)
  }
  // градусы в радианы
  function toRadians (angle) {
    return (angle + 180) * (Math.PI / 180);
  }
  
  function createGradTexture(startx, starty, endx, endy, overlay, ctx, offset) {
          
    const alfa = toRadians(overlay.angle)
    
    const height = endy - starty; 
    
    let radius
    // в зависимости от угла рассчитываем радиус по высоте или по ширине
    if (Math.abs(Math.sin(alfa)) < Math.abs(Math.sin(Math.atan2(endx,height)))) {
  
        radius = Math.abs((endy / 2) / Math.cos(alfa))
        const b1 = Math.abs(Math.tan(alfa) * (endy / 2))
        const b2 = (endx / 2) - b1
        const c2 = Math.abs(b2 * Math.sin(alfa))
        radius += c2
    } else {
  
        radius = Math.abs((endx / 2) / Math.sin(alfa))
        const a1 = Math.abs((endx / 2) / Math.tan(alfa))
        const a2 = (endy / 2) - a1
        const c1 = Math.abs(Math.cos(alfa)) * a2
        radius += c1
    }
    
    const angle = toRadians(overlay.angle) - Math.PI / 2;
    const gx = radius * Math.cos(angle);
    const gy = radius * Math.sin(angle);
    const cx = (startx + endx) / 2;
    const cy = (starty + endy) / 2;
  
    // console.log(cx - gx,cy - gy, cx + gx, cy + gy);
    
    // при позиционировании градиента на канвасе учитываем отступы кропа изображения
    const grd = ctx.createLinearGradient(cx - gx - offset.x, cy - gy - offset.y, cx + gx - offset.x, cy + gy - offset.y);
    grd.addColorStop(0, overlay.secondColor);
    grd.addColorStop((100 - overlay.transition) / 100, overlay.secondColor);
    grd.addColorStop(1, overlay.firstColor);
    ctx.fillStyle = grd;
    ctx.fillRect(-offset.x, -offset.y, endx, endy);
  }
  
export function getPixelColor(e, src, width, height, originalDimensions, scale, offset, hasParallax, colorBG, overlayType, gradientLayers) {
    // координаты пикселя, на который кликнули
    let x = e.pageX - e.target.getBoundingClientRect().left
    let y = e.pageY - e.target.getBoundingClientRect().top
    // создаём канвас, у которого будем брать цвет пикселя
    let canvas = document.createElement('canvas')
  
    // const workspaceElement = document.querySelector('#workspace')
    // const rootElement = document.querySelector('.root-container')
    // const endX = workspaceElement.getBoundingClientRect().right
    // const endY = workspaceElement.getBoundingClientRect().height
    // let canvas1 = document.createElement('canvas')
    // canvas1.width = endX;
    // canvas1.height = endY
    // let ctx = canvas1.getContext('2d')
    // gradientLayers.forEach(gradient => {
    //   createGradTexture(0, 0, endX, endY, gradient, ctx)
    // })
    // canvas1.style.position = 'absolute'
    // canvas1.style.top = 0
    // canvas1.style.left = 0
    // rootElement.append(canvas1)
  
    
    if (!hasParallax) {
      let colorRGBA
      if (overlayType === 'color') {
        colorRGBA = colorBG
        // console.log('resultColor',colorRGBA);
      }
      else if ( overlayType === 'gradient') {
        canvas.width = width
        canvas.height = height
        let context = canvas.getContext('2d')
        gradientLayers.forEach(gradient => {
          createGradTexture(0 , 0, width, height, gradient, context, {x: 0, y: 0})
        })
        let pixel = context.getImageData(x, y, 1, 1).data
        colorRGBA = `rgba(${pixel[0]}, ${pixel[1]}, ${pixel[2]}, ${Math.floor(pixel[3] * 100 / 255) / 100})`
        // console.log('resultColor',colorRGBA);
      }
      
      let colorHex = rgbaToHex(rgbaToArray(colorRGBA)).substr(0, 7)
  
    //   console.log('colorHex1',colorHex);
      colorHex = colorHex.substr(1, 7)
    //   console.log('colorHex2',colorHex);
      fallbackCopyTextToClipboard(colorHex)
      renderColorToast(colorRGBA)
      return
    }
    
  
    let baseImage = new Image()
    baseImage.crossOrigin = 'Anonymous'
    baseImage.src = `https://static.wixstatic.com/media/${src}`
    // console.log(baseImage.src)
    baseImage.onload = () => {
      // console.log(scale)
      canvas.width = scale != '' ? width * scale : width
      canvas.height = scale != '' ? baseImage.height / baseImage.width * width * scale : baseImage.height / baseImage.width * width
      let context = canvas.getContext('2d')
      if (scale != '') {
        context.drawImage(baseImage, 0, 0, width * scale, baseImage.height / baseImage.width * width * scale)
      } else {
        context.drawImage(baseImage, 0, 0, width, baseImage.height / baseImage.width * width)
      }
      
      // заливка картинки
      if (overlayType === 'color') {
        context.fillStyle = colorBG;
        context.fillRect(0, 0, canvas.width, canvas.height);
      } 
      else if ( overlayType === 'gradient') {
        gradientLayers.forEach(gradient => {
          // для каждого слоя градиента создаём свой слой текстуры
          createGradTexture(0 , 0, width, height, gradient, context, offset)
        })
      }
  
    // const rootElement = document.querySelector('.root-container')
    // canvas.style.position = 'absolute'
    // canvas.style.top = 0
    // canvas.style.left = 0
    // rootElement.append(canvas)
  
      let pixel = context.getImageData(x - offset.x, y - offset.y, 1, 1).data
      // альфа канал приходит в диапазоне 0-255, переводим его в диапазон 0-1
      const colorRGBA = `rgba(${pixel[0]}, ${pixel[1]}, ${pixel[2]}, ${Math.floor(pixel[3] * 100 / 255) / 100})`
    //   console.log('colorRGBA',colorRGBA);
      let colorHex = rgbaToHex(rgbaToArray(colorRGBA)).substr(0, 7)
    //   console.log('colorHex',colorHex);
      colorHex = colorHex.substr(1, 7)
      fallbackCopyTextToClipboard(colorHex)
      renderColorToast(colorRGBA)
    }
  }

  // выделение текста внутри contenteditable элемента
  export function selectElementContents(el) {
    const range = document.createRange();
    range.selectNodeContents(el);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
}

// округление положения элементов по сетке
export function roundCaptionForGrid(value, exp) {
  let type = 'round'
  if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
  }
  value = +value;
  exp = +exp;
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
  }
  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}

export function keyDownMoveHandler({event, index, editingCaptionIndex, transformPosition, stateTempPosition, isMoveElement, editingText, callback, dropdownIsOpen}) {
  if (!isMoveElement || editingText || dropdownIsOpen) return
  // if (editingCaptionIndex !== index) return
  // проверяю что не инпут, чтобы если текст выделен и в это время в слайдере меняется значение с помощью кнопок
  // чтобы текст не менял позицию 
  if (event.target.tagName.toLowerCase() === 'input') {
      return
  }

  if (event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40) {
      let position = transformPosition
      let tempPosition
      if (stateTempPosition) {
          tempPosition = stateTempPosition
      } else {
          tempPosition = { x: 0, y: 0 }
          // this.setState({tempPosition: tempPosition})
      }

      const delta = event.shiftKey ? 10 : 1
      // console.log('delta',delta);
      switch (event.keyCode) {
          case 37:
              position.x -= delta
              tempPosition.x -= delta
              break;
          case 38:
              position.y -= delta
              tempPosition.y -= delta
              break;

          case 39:
              position.x += delta
              tempPosition.x += delta
              break;

          case 40:
              position.y += delta
              tempPosition.y += delta
              break;
      }
      // this.setState({shapeStyle: {...this.state.shapeStyle, position}, tempPosition})
      callback(position, tempPosition)
  }
}

export function keyUpMoveHandler({event, isMoveElement, stateTempPosition, callback, editingText, dropdownIsOpen}) {
  if (!isMoveElement || editingText || dropdownIsOpen) return
  if (stateTempPosition && (event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40)) {
    callback()
  } 
}
